import { render, staticRenderFns } from "./florists-table.vue?vue&type=template&id=fb6e9270&scoped=true"
import script from "./florists-table.vue?vue&type=script&lang=js"
export * from "./florists-table.vue?vue&type=script&lang=js"
import style0 from "./florists-table.vue?vue&type=style&index=0&id=fb6e9270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6e9270",
  null
  
)

export default component.exports